module.exports = __webpack_public_path__ + "static/media/acknowledge.16a597e7.png";